<template>
	<div>
		<v-container align="center" justify="center" class="pa-5">
			<v-row class="justify-center text-center"
				><v-col>
					<v-card :max-width="483" elevation="5" :max-height="327" mx-auto class="mx-auto">
						<v-img
							mx-auto
							class="mx-auto justify-center text-center"
							:max-width="483"
							:max-height="327"
							src="https://media.giphy.com/media/xTiTnEHBh7qapyuvwQ/giphy.gif"
						>
						</v-img>
					</v-card>
					<!-- <v-avatar size="175" color="green"><v-img max-width="95" max-height="200" contain :src='require("@/assets/images/complete signup/party.svg")'></v-img></v-avatar> -->
				</v-col></v-row
			>
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap pb-2"><h1>Congrats!</h1></v-list-item-title>
					<v-list-item-subtitle class="text-center text-wrap pt-2">Your <a @click="openLocumPreview">profile</a> is looking strong 💪</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-container>
	</div>
</template>

<script>
import { bus } from '@/main';
import router from '@/router';
import { Tracking } from '@/utils';

export default {
	components: {},
	data: () => ({
		step: 'completed-step',
	}),

	mounted() {
		Tracking.track('Locum_Profile_Complete', {});
		window.scrollTo(0, 0);
		bus.$on('intent:submit-forms', () => {
			bus.$emit('update:spinning', true);

			router.push('/');
		});
		bus.$emit('update:next-button-text', 'Set Availability');
		bus.$emit('update:next-button-color', '#63C367');
		bus.$emit('push:notification@hide');
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
	},

	methods: {
		openLocumPreview() {
			bus.$emit('show-locum-preview-popup');
		},
	},
};
</script>
